// dependencies
import React, { useState, useMemo } from 'react'
import { string } from 'prop-types'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { styled, Typography, Container, Box, Button } from '@mui/material'
// helpers
import { useModalsContext } from '@context/modalContext'
// components

const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1.2rem',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const StyledTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '11px',
  p: {
    fontSize: '16px',
    fontWeight: '600',
    color: theme.palette.primary.dark,
  },
  svg: {
    width: '24px',
    height: '100%',
    color: theme.palette.primary.dark,
    marginRight: '5px',
  },
}))

const StyledSuccessMessageContainer = styled(Box)(({ theme }) => ({
  p: {
    color: theme.palette.secondary.dark,
    fontWeight: '600',
    fontSize: '16px',
  },
  svg: {
    fill: theme.palette.success.main,
    width: '64px',
    height: '64px',
  },
}))

const StyledActionsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '30px',
}))

const StyledButton = styled(Button)(() => ({}))

export default function SubscribeForm({ title, message, email }) {
  const { actions } = useModalsContext()
  return (
    <StyledContainer>
      <StyledTitleContainer>
        <InfoOutlined />
        <Typography>{title}</Typography>
      </StyledTitleContainer>
      <StyledSuccessMessageContainer>
        {message}
        <Typography>{`${email}.`}</Typography>
      </StyledSuccessMessageContainer>
      <StyledActionsContainer>
        <StyledButton onClick={actions.close} color="primary" variant="text" aria-label="Close">
          CANCEL
        </StyledButton>
        <StyledButton
          onClick={actions.forgotPassword}
          color="primary"
          variant="contained"
          aria-label={`Forgot Password for ${email}`}
        >
          FORGOT PASSWORD
        </StyledButton>
      </StyledActionsContainer>
    </StyledContainer>
  )
}

SubscribeForm.propTypes = {
  title: string,
  message: string,
  email: string,
}
